import { useEffect } from "@wordpress/element";

const Style = ({ attributes, setAttributes }) => {
  const { uniqueId, background, headingFontSize, descFontSize, buttonGap, color, btnColor, btnBG, closeBtnColor, closeBtnBG, CSS } = attributes;

  useEffect(() => {
    const CSS = `#${uniqueId} .popup{background: ${background};color: ${color}}#${uniqueId} .heading{font-size: ${headingFontSize}}#${uniqueId} .text{font-size: ${descFontSize}}#${uniqueId} .form {gap: ${buttonGap}}#${uniqueId} .form .submit {color: ${btnColor}; background: ${btnBG}}#${uniqueId} .close {color: ${closeBtnColor}; background: ${closeBtnBG}}`;

    setAttributes({ CSS });
  }, [uniqueId, background, headingFontSize, descFontSize, buttonGap, color, btnColor, btnBG, closeBtnColor, closeBtnBG]);

  return <style>{CSS}</style>;
};
export default Style;
